import { useDispatch, useSelector } from "react-redux"
// import { isMobile } from "react-device-detect"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, GetLoginCredentialDb } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
  VirtualizeAutoComplete,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Autocomplete,
  AutocompleteItem,
  useDisclosure,
} from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFilter,
  faMagnifyingGlass,
  faReceipt,
} from "@fortawesome/free-solid-svg-icons"
import { resetReportDetail, setInvoiceDetail } from "../../state/invoiceSlice"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"

import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import { enum_Report_Type } from "../report/ReportUtility"
import ReportViewer from "../report/ReportViewer"
import { useNavigate } from "react-router-dom"
import { resetPayVoutDetail } from "../../state/paymentEntrySlice"
import { resetRecVouDetail } from "../../state/receiveEntrySlice"


const SalesData = () => {
  let disapatch = useDispatch()
  const enum_filterFieldId = {
    account: "accountId",
    party: "partyId",
    unit: "unitId"
  }
  let { compCode, yearId } = useSelector((state) => state.company)
  const { user, token } = useSelector((state) => state.auth)
  //const navigate=useNavigate();
  //const [data, setData] = useState([])

  let [selectedAccount, setSelectedAccount] = useState("")
  let [selBillType, setSelBillType] = useState("S")
  const [data, setData] = useState([])

  // {
  //   key: "",
  //   value: ""
  // }
  let [selectedParty, setSelectedParty] = useState("")
  // ({
  //   key: "",
  //   value: ""
  // })
  const [selectedUnit, setSelectedUnit] = useState("")
  let [filterDate, setFilterDate] = useState({
    start: null,
    end: null,
  })
  const {
    isOpen: isOpenReportModel,
    onOpen: onOpenReportModel,
    onOpenChange: onOpenReportModelChange,
  } = useDisclosure()


  const { isError: isErrorFetch, data: itemMasterData = [], mutate: getMasterData } = usePost({
    url: apiRoute.report.masterdata.fetchAccount,
    queryKey: "AccountList",

  })

  const { isLoading, data: unitMaster = [] } = useFetchWithBody({
    url: apiRoute.report.invoice.getUnit,
    queryKey: "Fetch Unit data",
    inputData: {
      compcode: compCode.join(",")
    }
  })

  useEffect(() => {
    if (selBillType != "" && selBillType != null) {
      getMasterData({
        data: {
          compcode: compCode[0],//.join(","),
          bill_type: selBillType
        }
      })

    }
    setData([])
    setSelectedAccount("")
    //else
    //setSelBillType('S')
  }, [selBillType])
  // const handleDataChange = ({ data, isFilter }) => {
  //   //   console.log(data,isFilter)
  //   // if (selectedAccount.key != "0" && selectedAccount.key != "") {
  //   if (isFilter)
  //     setData(data)
  //   else
  //     setData(saleData)
  //   //
  // }

  const {
    isError,
    isPending,
    // data: saleData = [],
    data: reportData = [],
    mutate: filterInvoice,
  } = usePost({
    url: apiRoute.report.invoice.fetch,
    queryKey: "Invoice-List",
    onSuccessTasks: (data) => {
      setData(data)
    }

  })
  //console.log(data, saleData)

  // useEffect(() => {
  //   //console.log(saleData)
  //   if (selectedAccount.key != "0" && selectedAccount.key != "")
  //     setData(saleData)
  // }, [saleData])

  const funInvoiceData = () => {



  }

  const handleVirtualizeChanged = (data) => {
    let id = data.id
    if (id == enum_filterFieldId.account) {
      setSelectedAccount({ key: data.selectedKey, value: data.selectedValue })
      // if (saleData && saleData.length <= 0)
      //   funInvoiceData();
    }
    else if (id == enum_filterFieldId.party)
      setSelectedParty({ key: data.selectedKey, value: data.selectedValue })
  }

  let totalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "invoice_amount",
      }),
    [data]
  )

  let totalPcs = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "pcs",
      }),
    [data]
  )
  let totalMeter = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "meter",
      }),
    [data]
  )
  let totalWeight = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "weight",
      }),
    [data]
  )


  const INITIAL_VISIBLE_COLUMNS = [
    "party_name",
    "invoice_no",
    "Invoice_Det",
    "pcs",
    "meter",
    "weight",
    "invoice_amount",
    "invoice_date",
    "account_name",
    "actions",
  ]
  let downloadDataFooter = {
    party_name: "",
    invoice_no: "",
    Invoice_Det: "",
    invoice_amount: "Total: " + totalAmt,
    invoice_date: "",
    account_name: "",
  }


  const columns = [
    {
      name: "PARTY NAME",
      uid: "party_name",
      sortable: true,
      //filter:true,
    },
    {
      name: "BILL NO",
      uid: "invoice_no",
      sortable: true,

    },
    {
      name: "Items",
      uid: "Invoice_Det",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.multiline
    },
    {
      name: "PCS",
      uid: "pcs",
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalPcs,
      },

    },
    {
      name: "METER",
      uid: "meter",
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalMeter,
      },

    },
    {
      name: "WEIGHT",
      uid: "weight",
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalWeight,
      },

    },
    {
      name: "AMOUNT",
      uid: "invoice_amount",
      sortable: true,
      //filter:true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmt,
      },
    },
    {
      name: "DATE",
      uid: "invoice_date",
      type: COLUMN_TYPE.date,
      sortable: true,
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
      sortable: true,
    },
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
  ]

  const exportColumns = [
    {
      name: "PARTY NAME",
      uid: "party_name",
    },
    {
      name: "BILL NO",
      uid: "invoice_no",
    },
    {
      name: "Items",
      uid: "Invoice_Det",
    },
    {
      name: "PCS",
      uid: "pcs",
    },
    {
      name: "METER",
      uid: "meter",
    },
    {
      name: "WEIGHT",
      uid: "weight",
    },
    {
      name: "AMOUNT",
      uid: "invoice_amount",
    },
    {
      name: "DATE",
      uid: "invoice_date",
      type: COLUMN_TYPE.date,
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
    },

  ]
  const rowActionBtn = [
    {

      icon: selBillType == 'S' ? <FontAwesomeIcon icon={faReceipt} /> : "",
      onClick: (row) => {
        let obj = {
          token: token,
          comp_code: row.compcode,
          acid: null,
          billno: row.invoice_no,
          billtype: "S",
          db_user: GetLoginCredentialDb(user, yearId)
        }

        disapatch(resetPayVoutDetail())
        disapatch(resetRecVouDetail())
        disapatch(resetReportDetail())
        disapatch(setInvoiceDetail(obj))
        // navigate(linksUrl.report.invoice.rptInvoice)
        onOpenReportModel()
      },
      label: selBillType == 'S' ? "Print" : "",
      // label:"Print",
      color: selBillType == 'S' ? "bg-sky-600" : "",
      type: selBillType == 'S' ? ROW_ACTION_BTN_TYPE.button : ROW_ACTION_BTN_TYPE.link,
      // type: ROW_ACTION_BTN_TYPE.link,
    },
  ]


  const handleFilter = () => {

    if (selectedAccount != "0" && selectedAccount != "" && selBillType != "" && selBillType != null) {
      filterInvoice({
        data: {
          compcode: compCode.join(","),
          fromdate: filterDate.start
            ? new Date(filterDate.start).toISOString().split("T")[0]
            : null,
          todate: filterDate.end
            ? new Date(filterDate.end).toISOString().split("T")[0]
            : null,
          bill_type: selBillType,
          acid: selectedAccount != null && selectedAccount != "" && selectedAccount != "0" ? selectedAccount : "",
          pacid: selectedParty != null && selectedParty != "" && selectedParty != "0" ? selectedParty : "",
          lacid: selectedUnit != null && selectedUnit != "" && selectedUnit != "0" ? selectedUnit : "",
        },
      })
    } else {

      toast.error("Please select Account And Report Type !", {
        position: "top-center",
      })
    }
  }


  const handleResetFilter = () => {
    setFilterDate({
      start: null,
      end: null,
    })
    setData([])
    // filterInvoice({
    //   data: {
    //     compcode: compCode.join(","),
    //     fromdate: null,
    //     todate: null,
    //     bill_type: 'S',
    //     acid: selectedAccount != null && selectedAccount != "" && selectedAccount != "0" ? selectedAccount : "",
    //   },
    // })
    setSelectedUnit("")
    setSelectedAccount("")
    setSelBillType("S")
    setSelectedParty("") //{ key: "", value: "" })
  }
  const reportModel = () => {
    return (
      <div>
        <Modal
          isOpen={isOpenReportModel}
          onOpenChange={onOpenReportModelChange}
          size="xl"
          placement="center"
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="flex flex-row gap-1">
                  Invoice
                </ModalHeader>
                <ModalBody className="overflow-auto ">
                  <div className="flex flex-col">
                    <ReportViewer props_ReportType={enum_Report_Type.SALESINVOICE} />
                  </div>
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    )
  }
  if (isError || isErrorFetch) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }
  return (
    <div>
      <MainContainer
        pageName="Sales / Purchase Data"
        info={[]}
        breadcrumbs={["Sales", "Sales / Purcahse Data"]}
      >
        <div className="flex felx-wrap mb-2   bg-gray-10 shadow p-3">
          <div className="flex  flex-wrap items-center gap-2 justify-center ">
            <div className="flex  items-center gap-2 ">
              <Autocomplete
                size="sm"
                name={enum_filterFieldId.selBillType}
                // isInvalid={errors[item.name]}
                // errorMessage={errors[item.name]}
                label={"Report Type"}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}
                className="max-w-23"
                isClearable={true}
                isVirtualized
                variant="flat"
                color="danger"
                onSelectionChange={setSelBillType}
                selectedKey={selBillType}
              >

                <AutocompleteItem key={'S'}    >
                  SALE
                </AutocompleteItem>
                <AutocompleteItem key={'P'}    >
                  PURCHASE
                </AutocompleteItem>

              </Autocomplete>
              <Autocomplete
                size="sm"
                name={enum_filterFieldId.account}
                // isInvalid={errors[item.name]}
                // errorMessage={errors[item.name]}
                label={"Account"}

                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}
                className="max-w-23"
                isClearable={true}
                variant="flat"
                color="warning"
                isVirtualized
                defaultItems={
                  itemMasterData && itemMasterData.accData ?
                    itemMasterData && itemMasterData.accData
                    : []
                }
                onSelectionChange={setSelectedAccount}
                selectedKey={selectedAccount}
              >
                {(list) => (
                  <AutocompleteItem

                    key={list.Party_Id}
                  >
                    {list.Party_Name}
                  </AutocompleteItem>
                )}
              </Autocomplete>
            </div>
            <div className="flex  items-center gap-2 ">

              <Autocomplete
                size="sm"
                name={enum_filterFieldId.unit}
                // isInvalid={errors[item.name]}
                // errorMessage={errors[item.name]}
                label={"Unit"}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}
                className="max-w-23"
                isClearable={true}
                variant="bordered"
                isVirtualized
                defaultItems={
                  unitMaster || []
                }
                onSelectionChange={setSelectedUnit}
                selectedKey={selectedUnit}
              >
                {(list) => (
                  <AutocompleteItem

                    key={list.Party_Id}
                  >
                    {list.Party_Name}
                  </AutocompleteItem>
                )}
              </Autocomplete>
              <Autocomplete
                size="sm"
                name={enum_filterFieldId.party}
                label={"Party Name"}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}
                className="max-w-23"
                isClearable={true}
                variant="bordered"
                isVirtualized
                defaultItems={
                  itemMasterData && itemMasterData.partyData ?
                    itemMasterData && itemMasterData.partyData
                    : []
                }
                onSelectionChange={setSelectedParty}
                selectedKey={selectedParty}
              >
                {(list) => (
                  <AutocompleteItem

                    key={list.Party_Id}
                  >
                    {list.Party_Name}
                  </AutocompleteItem>
                )}
              </Autocomplete>
            </div>

            {/* date */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label={"Start Date"}
                views={["day", "month", "year"]}
                format="DD/MM/YYYY"
                value={
                  filterDate.start
                    ? dayjs(filterDate.start)
                    : filterDate.start
                }
                onChange={(newValue) => {
                  setFilterDate((prev) => {
                    return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                  })
                }}
                sx={{ width: "145px" }}
                slotProps={{ textField: { size: "small" } }}
              />
              <DatePicker
                label={"End Date"}
                views={["day", "month", "year"]}
                format="DD/MM/YYYY"
                value={
                  filterDate.end ? dayjs(filterDate.end) : filterDate.end
                }
                onChange={(newValue) => {
                  setFilterDate((prev) => {
                    return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                  })
                }}
                slotProps={{ textField: { size: "small" } }}
                sx={{ width: "145px" }}
              />
            </LocalizationProvider>
            <div className="flex  items-center gap-2 ">
              <Button
                size="sm"
                color="danger"
                startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                onPress={handleFilter}
                className="uppercase"
              // isLoading={isPending}
              >
                Show
              </Button>
              <Button
                size="sm"
                style={{ marginLeft: "5px" }}
                color="warning"
                startContent={<FontAwesomeIcon icon={faFilter} />}
                onPress={handleResetFilter}
                className="uppercase bg-slate-700 text-white"
              >
                Reset 
              </Button>
            </div>
          </div>

        </div>
        {reportModel()}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          //handleDataChange={handleDataChange}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          showAdvanceFilter={false}
          downloadFileName="SalesData-List"
          id="SalesData"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default SalesData

// const formatResult = (itemMasterData) => {
//   return (
//     <span style={{ display: "block", textAlign: "left", fontSize: "10.5px" }}>
//       {itemMasterData.Party_Name}
//     </span>
//   )
// }
// const handleOnSelect = (item) => {
//   //  setSelectedAccount(item.Party_Id)
// }
// <div className="mb-3">
//            <ReactSearchAutocomplete
//             items={itemMasterData}
//             fuseOptions={{ keys: ["Party_Name", "Party_Id"] }}
//             resultStringKeyName="Party_Name"
//             showIcon={false}
//             onClear={handleClear}
//             onSelect={handleOnSelect}
//             value={selectedAccount}
//             showItemsOnFocus={true}
//             placeholder="Select Account"
//             autoFocus
//             formatResult={formatResult}
//             styling={{
//               height: "40px",
//               border: "1px solid #dfe1e5",
//               borderRadius: "5px",
//               color:  "#131516" ,
//               placeholderColor: "red",
//               backgroundColor: "#ffffff" ,  //isMobile ? "#ffffff" :
//               iconColor:  "#131516", //isMobile ? "#131516"
//               fontSize: "14px",
//               zIndex: isOpenReportModel ? "0" : "9999",
//             }}
//           />

//         </div>
// const handleClear = () => {
//   setFilterAccount({
//     accountId: "Account",
//     partyId: "Party"
//   })
//   filterInvoice({
//     data: {
//       compcode: compCode.join(","),
//       fromdate: null,
//       todate: null,
//       acid: "0",
//     },
//   })
//}